import type { InputHTMLAttributes } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  mono?: boolean;
}

export function Input({ mono, style, className = 'focusable', ...rest }: InputProps) {
  return (
    <input
      {...rest}
      className={className}
      style={{
        width: '100%',
        padding: '8px 11px',
        fontSize: 13.5,
        background: 'var(--bg-0)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--r-sm)',
        color: 'var(--text-0)',
        outline: 'none',
        transition: 'border-color 0.14s',
        ...(mono ? { fontFamily: 'var(--font-mono)' } : {}),
        ...style
      }}
    />
  );
}
